import React from 'react'
import { Card, Drawer, Form, Icon, notification, Button, Tooltip } from 'antd'
import _ from 'lodash'
import { connect } from 'react-redux'
import InvoicePDF from '../pdf/invoicePDF'

import Request, { MEDIA_URL } from '../../request'

class InvoiceView extends React.Component {
    state = {
        visible: true,
        invoiceId: '',
        generatedInvoice: {},
        cardLoading: false
    }

    onClose = () => {
        this.setState({
            visible: false
        })

        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }

    loadInvoiceDetail = async () => {
        const { invoiceId } = this.props;
        this.setState({ cardLoading: true });
        const res = await Request.getInvoiceDetail(invoiceId);
        this.setState({ cardLoading: false });
        if (!res.error) {
            this.setState({ generatedInvoice: res.doc });
        }
    }

    componentWillMount() {
        this.loadInvoiceDetail();
    }

    downloadInvoice = () => {
        const { generatedInvoice } = this.state;
        let url = `${MEDIA_URL}${generatedInvoice.invoiceUrl}`;
        window.open(url, '_blank');
        // if (generatedInvoice.invoiceStatus == 'Generated') {
        //     var printContents = document.getElementById('table_with_data').innerHTML;
        //     var originalContents = document.body.innerHTML;
        //     document.body.innerHTML = printContents;
        //     window.print();
        //     document.body.innerHTML = originalContents;
        // } else {
        //     let url = `${MEDIA_URL}${generatedInvoice.invoiceUrl}`;
        //     window.open(url, '_blank');
        // }
    }

    sendInvoice = () => {
        const { invoiceId } = this.props;
        this.props.onSendInvoice(invoiceId);
        this.props.onClose();
    }

    render() {
        const { generatedInvoice, cardLoading } = this.state;
        return (
            <Drawer
                title={
                    <div>
                        {'Invoice'} {' '}
                        <a onClick={this.onClose} style={{ float: 'right', color: 'black' }}>
                            <Icon type={'close'} />
                        </a>
                    </div>
                }
                placement="right"
                closable={false}
                onClose={this.onClose}
                width={generatedInvoice.invoiceThroughCp ? 1250 : 1000}
                visible={this.state.visible}>
                <div>
                    <Tooltip title="Download Invoice ">
                        <Button
                            loading={false}
                            shape="circle"
                            icon="download"
                            onClick={() => { this.downloadInvoice() }}
                        />
                    </Tooltip>
                    {
                        generatedInvoice.invoiceStatus == 'Generated' ?
                            <Tooltip title="Send invoice to next">
                                <Button
                                    loading={false}
                                    shape="circle"
                                    icon="forward"
                                    onClick={() => { this.sendInvoice() }}
                                />
                            </Tooltip>
                            : null
                    }
                    <Card id='table_with_data' loading={cardLoading}>
                        <table style={{ width: '100%' }}>
                            <tbody>
                                <tr>
                                    <td>
                                        <InvoicePDF generatedInvoice={generatedInvoice} />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </Card>
                </div>
            </Drawer>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(InvoiceView)